<template>
    <div id="CurrentYearImportExportTotal">
        <div class="num">
            <span>{{  formatNumber(data.totalValue)  }}</span>
        </div>
        <div class="title">进出口总额</div>
        <img class="m-auto" src="@/assets/img/Group23.png" alt="">

        <div class="c-num-item">
            <div>出口总额</div>
            <div class="number">
                {{ formatNumber(data.exportValue)  }}万元
            </div>
        </div>

        <div style="" class=" j-num-item">
            <div>进口总额</div>
            <div class="number">
                {{ formatNumber(data.importValue)  }}万元
            </div>
        </div>

    </div>
</template>

<script>

import {
    formatNumber
} from '@/utils/tools'

export default {
    name: "",
    components: {
    },
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {

            dataList: []
        };
    },
    watch: {},
    computed: {},
    methods: {
        formatNumber,
        async init() {
            //综试区发展指数-中下
            try {
                const res = await cmsSysCloudlsdDevelopIndex()
                this.dataList = res.data
            } catch (err) {
                this.$message.error("数据加载失败")
            }

        }
    },
    created() { },
    async mounted() {
    }
}
</script>
<style lang="scss" scoped>
#CurrentYearImportExportTotal {
    text-align: center;
    position: relative;
    padding-top: 25px;

    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #9e9a9a;
        line-height: 24px;
        font-style: normal;
        text-transform: none;
        position: absolute;
        top: 83px;
        width: 100%;
    }

    .num {
        width: 100%;
        font-family: D-DIN-PRO, D-DIN-PRO;
        font-weight: 800;
        font-size: 25px;
        line-height: 25px;
        // letter-spacing: 5px;
        text-shadow: 0px 0px 16px rgba(61, 255, 255, 0.5);
        font-style: normal;
        text-transform: none;
        position: absolute;
        top: 112px;
        color: #3DFFFF;

        background: linear-gradient(90deg, #55FFF5, #DAFFFD);
        /* 渐变色 */
        -webkit-background-clip: text;
        /* 用文字形状裁剪背景 */
        -webkit-text-fill-color: transparent;
        /* 让文字填充透明 */
    }

    .j-num-item {
        position: absolute;
        top: 32px;
        right: 50px;
        text-align: left;

    }

    .c-num-item {
        position: absolute;
        bottom: 3px;
        left: 50px;
        text-align: left;
        color: #DDEBF3;
    }

    .number {
        font-family: D-DIN-PRO, D-DIN-PRO;
        font-weight: bold;
        letter-spacing: 1px;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(90deg, #9FC7DD 0%, #FFFFFF 100%);
        /* 渐变色 */
        -webkit-background-clip: text;
        /* 用文字形状裁剪背景 */
        -webkit-text-fill-color: transparent;
        /* 让文字填充透明 */
    }

}
</style>